"use client";
import type BigNumber from "bignumber.js";
import { MouseEvent, useState } from "react";

import { formatNum } from "@/util/format";
import { formatCoin } from "@/util/format-coin";

import {
  DetailsBlock,
  DetailsBlockHeading,
  DetailsUnit,
  InfoIcon,
} from "../trade.styled";

const Details = ({
  liquidationPrice,
  fundingRate,
  quoteSymbol,
  className,
}: {
  liquidationPrice: BigNumber;
  fundingRate: number;
  quoteSymbol: string;
  className?: string;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <DetailsBlock className={(expanded ? "expanded" : "") + " " + className}>
      <DetailsBlockHeading
        onClick={(e: MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded((expanded) => !expanded);
        }}
      >
        Details
        <InfoIcon />
      </DetailsBlockHeading>
      <DetailsUnit>
        <div>Estimated funding rate</div>{" "}
        <div>{formatNum(fundingRate, { dp: 2, postfix: "%" })}</div>
      </DetailsUnit>

      <DetailsUnit>
        <div>Liquidation price</div>
        <div>
          {formatCoin(liquidationPrice)} {quoteSymbol}
        </div>
      </DetailsUnit>
    </DetailsBlock>
  );
};

export default Details;
